import React from 'react';
import { Composition } from 'remotion';
import { VideoStudioCompositie, type CompositieProps } from './VideoStudioCompositie.js';

/**
 * De compositieregistratie.
 *
 * `calculateMetadata` neemt de duur en afmetingen uit `inputProps` over. De
 * aanroeper berekent de duur met dezelfde functie als de tijdlijn in de
 * webapp (berekenDuurInFrames). Eén bron van waarheid, geen tweede telling.
 */

export const COMPOSITIE_ID = 'VideoStudio';

const LEEG_PROJECT = {
  id: 'leeg',
  naam: 'Leeg project',
  versie: 1,
  schemaVersie: 1 as const,
  fps: 30,
  beeldformaat: '16:9' as const,
  breedte: 1920,
  hoogte: 1080,
  achtergrond: { kleur: '#000000' },
  tracks: [],
  duurOverrideInFrames: null,
  gemaaktOp: new Date(0).toISOString(),
  gewijzigdOp: new Date(0).toISOString(),
};

export const VideoStudioRoot: React.FC = () => {
  return (
    <Composition
      id={COMPOSITIE_ID}
      component={VideoStudioCompositie}
      durationInFrames={30}
      fps={30}
      width={1920}
      height={1080}
      defaultProps={
        {
          project: LEEG_PROJECT,
          assetUrls: {},
          duurInFrames: 30,
        } satisfies CompositieProps
      }
      calculateMetadata={({ props }) => {
        const project = props.project;
        return {
          durationInFrames: Math.max(1, Math.round(props.duurInFrames ?? 1)),
          fps: project.fps,
          width: project.breedte,
          height: project.hoogte,
        };
      }}
    />
  );
};

export default VideoStudioRoot;
